import { observable } from "mobx";
import { Type } from "class-transformer";
import type BulkExemptionCreationErrorType from "./bulkExemptionCreationErrorType";
import type ExemptionCreationWarningReason from "./exemptionCreationWarningReason";
import VehicleRegisterVehicleClassifiedFuelType from "./vehicleRegisterVehicleClassifiedFuelType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class BulkExemptionPreviewItemResponse {
  /**
   * Row number of the item.
   */
  @observable
  rowNumber!: number;

  /**
   * Original vehicle registration plate.
   */
  @observable
  originalLicensePlate?: string;

  /**
   * Original country code.
   */
  @observable
  originalCountryCode?: string;

  /**
   * Parsed vehicle registration plate.
   */
  @observable
  licensePlate?: string;

  /**
   * Parsed country ID.
   */
  @observable
  countryId?: string;

  /**
   * Original valid since.
   */
  @observable
  originalValidSince?: string;

  /**
   * Original valid until.
   */
  @observable
  originalValidUntil?: string;

  /**
   * Parsed valid since.
   */
  @observable
  @Type(() => Date)
  validSince?: Date;

  /**
   * Parsed valid until.
   */
  @observable
  @Type(() => Date)
  validUntil?: Date;

  @observable
  vehicleClassifiedFuelType?: VehicleRegisterVehicleClassifiedFuelType;

  /**
   * Identified errors.
   */
  @observable
  errors!: BulkExemptionCreationErrorType[];

  /**
   * Warning reasons.
   */
  @observable
  warningReasons!: ExemptionCreationWarningReason[];
}
